import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../context/CartContext';
import { API_ENDPOINTS } from '../apiConfig';

const EshopPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auctionPrice, setAuctionPrice] = useState(14500);
  const { addToCart } = useCart();

  // Maintenance režim - přepni na false pro spuštění webu
  const [isMaintenance, setIsMaintenance] = useState(true);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.PRODUCTS);
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        setProducts([
          { id: 1, name: 'Ručně vyřezávaná miska z ořechu', price: 1200, image: 'images/miska.jpg' },
          { id: 2, name: 'Dřevěný drak - dekorace', price: 2500, image: 'images/drak.jpg' },
          { id: 3, name: 'Sada dlátek pro začátečníky', price: 850, image: 'images/sadadlat.jpg' },
          { id: 4, name: 'Podnos s reliéfem listu', price: 1450, image: 'images/podnos.jpg' },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleBid = async () => {
    if (!user) {
      alert("Pro přihazování v aukci se musíte nejdříve přihlásit.");
      window.location.href = '/login';
      return;
    }

    const minBid = auctionPrice + 100;
    const bidInput = prompt(`Aktuální cena je ${auctionPrice} Kč. Zadejte vaši částku (minimálně ${minBid} Kč):`);
    
    if (bidInput) {
      const amount = parseInt(bidInput);
      if (isNaN(amount) || amount < minBid) {
        alert(`Chyba: Příhoz musí být alespoň o 100 Kč vyšší než aktuální cena (tj. minimálně ${minBid} Kč).`);
        return;
      }

      try {
        // Logika pro backendistu:
        // await fetch(API_ENDPOINTS.AUCTION_BID, { method: 'POST', body: JSON.stringify({ userId: user.id, amount, itemId: 'strazce-lesa' }) });
        setAuctionPrice(amount);
        alert("Úspěšně přihazujete! Aukce byla přidána do vašeho profilu.");
      } catch (e) {
        alert("Chyba při odesílání příhozu.");
      }
    }
  };

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4e9dc' }}>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          style={{ width: '50px', height: '50px', border: '5px solid #d1b892', borderTopColor: 'transparent', borderRadius: '50%' }}
        />
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', minHeight: '100vh', backgroundColor: '#f4e9dc' }}>
      
      {/* --- MAINTENANCE OVERLAY --- */}
      {isMaintenance && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(244, 233, 220, 0.98)', zIndex: 9999,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            textAlign: 'center', padding: '20px', backdropFilter: 'blur(15px)'
          }}
        >
          <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <h2 style={{ fontSize: '3rem', color: '#2b1f18', marginBottom: '20px' }}>Na dílně se právě pracuje</h2>
            <p style={{ fontSize: '1.2rem', color: '#8b5a2b', maxWidth: '600px', margin: '0 auto 40px' }}>
              E-shop pro vás právě připravujeme a ladíme poslední detaily na našich dřevěných unikátech. 
              Brzy budeme mít otevřeno!
            </p>
            <button 
              onClick={() => window.location.href = '/'} 
              className="contact-button"
              style={{ padding: '15px 40px', cursor: 'pointer', background: '#2b1f18', color: '#fff', border: 'none', borderRadius: '8px' }}
            >
              Zpět na hlavní web
            </button>
          </motion.div>
        </motion.div>
      )}

      {/* --- ESHOP OBSAH --- */}
      <div style={{ 
        padding: '140px 20px 80px', maxWidth: '1200px', margin: 'auto', 
        filter: isMaintenance ? 'blur(5px)' : 'none',
        pointerEvents: isMaintenance ? 'none' : 'auto'
      }}>
        
        {/* SEKCE AUKCE */}
        <motion.section 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          style={{ 
            background: '#2b1f18', color: '#fff', borderRadius: '20px', padding: '40px', 
            marginBottom: '80px', display: 'flex', flexWrap: 'wrap', gap: '40px', 
            alignItems: 'center', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', border: '2px solid #d1b892'
          }}
        >
          <div style={{ flex: '1', minWidth: '300px' }}>
            <motion.span animate={{ opacity: [1, 0.5, 1] }} transition={{ repeat: Infinity, duration: 2 }} style={{ backgroundColor: '#d1b892', color: '#2b1f18', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold' }}>
              PRÁVĚ PROBÍHÁ AUKCE
            </motion.span>
            <h2 style={{ fontSize: '2.5rem', marginTop: '20px' }}>Socha "Strážce lesa"</h2>
            <p style={{ fontSize: '1.1rem', margin: '20px 0', color: '#ccc' }}>Unikátní socha z jednoho kusu dubového dřeva, výška 120cm.</p>
            <div style={{ display: 'flex', gap: '30px', marginBottom: '30px' }}>
              <div>
                <p style={{ color: '#aaa', fontSize: '0.9rem' }}>Aktuální příhoz</p>
                <p style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#d1b892' }}>{auctionPrice.toLocaleString()} Kč</p>
              </div>
              <div>
                <p style={{ color: '#aaa', fontSize: '0.9rem' }}>Zbývající čas</p>
                <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>2d 14h 5m</p>
              </div>
            </div>
            <button onClick={handleBid} className="contact-button" style={{ width: '100%', background: user ? '#d1b892' : '#666', border: 'none', cursor: 'pointer' }}>
              {user ? 'Přihodit do aukce' : 'Pro příhoz se přihlaste'}
            </button>
          </div>
          <div style={{ flex: '1', minWidth: '300px' }}>
            <img src="images/aukce-socha.jpg" alt="Aukční kousek" style={{ width: '100%', borderRadius: '15px', objectFit: 'cover' }} />
          </div>
        </motion.section>

        {/* SEKCE PRODEJ */}
        <section>
          <h2 style={{ fontSize: '2rem', marginBottom: '40px', textAlign: 'center', color: '#2b1f18' }}>Aktuální nabídka v dílně</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {products.map(product => (
              <motion.div key={product.id} whileHover={{ y: -10 }} style={{ background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 10px 20px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column' }}>
                <img src={product.image} alt={product.name} style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '10px', marginBottom: '15px' }} />
                <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#2b1f18' }}>{product.name}</h3>
                <p style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#8b5a2b', marginBottom: '20px' }}>{product.price.toLocaleString()} Kč</p>
                <button onClick={() => { addToCart(product); alert(`${product.name} byl přidán do košíku!`); }} className="contact-button" style={{ marginTop: 'auto', width: '100%', cursor: 'pointer' }}>
                  Koupit kousek
                </button>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default EshopPage;